module.exports = __webpack_public_path__ + "img/new_sale_pic.7a48501b.png";